/** Ids of the side nav modules, for surfaces that decorate a module by id. */
export const MODULE_DESTINATION_IDS = {
  profile: "module.profile",
  clients: "module.clients",
  schedule: "module.schedule",
  admin: "module.admin",
  practiceBilling: "module.practice-billing",
  messages: "module.messages",
  resources: "module.resources",
  tests: "module.tests",
  settings: "module.settings",
} as const;

export type ModuleDestinationId =
  (typeof MODULE_DESTINATION_IDS)[keyof typeof MODULE_DESTINATION_IDS];
